export default __webpack_public_path__ + "img/cFDnxZVe.b745a0b9.svg";